export const validGoogleMapsUrl = (value) => {
  if (typeof value !== "string" || !value.trim()) return "";
  try {
    const url = new URL(value.trim());
    if (url.protocol !== "https:" || url.username || url.password || url.port) return "";
    const host = url.hostname;
    const isMaps = host === "maps.app.goo.gl" ||
      (["maps.google.com", "maps.google.co.th"].includes(host)) ||
      (["google.com", "www.google.com", "google.co.th", "www.google.co.th", "goo.gl"].includes(host) && /^\/maps(?:\/|$)/.test(url.pathname));
    return isMaps ? url.href : "";
  } catch {
    return "";
  }
};

export const customerMapsUrl = (customer) => {
  const savedUrl = validGoogleMapsUrl(customer.googleMapsUrl);
  if (savedUrl) return savedUrl;
  const address = typeof customer.locationAddress === "string" ? customer.locationAddress.trim() : "";
  if (!address) return "";
  const name = customer.CustomerNameTH || customer.CustomerNameEN || "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${name} ${address}`.trim())}`;
};
